enum ClaimsTableType {
  MyClaims = 'MyClaims',
  ClaimsAgainstMe = 'ClaimsAgainstMe',
  UnderReviewClaims = 'UnderReviewClaims',
}
export default ClaimsTableType;
